import React, { useEffect, useState } from "react";
import { fieldsFormContracts } from "../helper/fieldsFormContract";
import { DatePickerConfig } from "pages/autorization-payments";
import { buildDatePickerRange } from "shared/utils/helpers/buildDatePickerRange";
import { useFormik } from "formik";
import {
  accesRoles,
  Dispatch,
  GET_CONTACT_NUMBER,
  RootState,
  GET_CONTRACTS_NUMBER,
  apiInstance,
} from "shared";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { columnsGridContracts } from "../helper/columnsGridContracts";
import { MenuActions } from "pages/autorization-payments/components/MenuActions";
import { ButtonAction, CustomFileUploader } from "shared/components";
import { Link } from "react-router-dom";
import { columnsContractsType } from "../types/columsContract.types";
import { ModalContract } from "../ModalContract";
import { MenuItem } from "@mui/material";

export const useContracts = () => {
  const dispatch = useDispatch<Dispatch>();
  const { content, paramsUrl } = useSelector(
    (state: RootState) => state.electronicDocuments,
  );
  const { id } = useSelector((state: RootState) => state.linkDocument);
  const { loading } = useSelector(
    (rootState: RootState) => rootState.loading.models.linkDocument,
  );
  const [dataFields, setDataFields] = useState<any[]>([]);
  const [contractDateAt, setContractDateAt] = useState<any[]>([null, null]);
  const [startContractDateAt, endContractDateAt] = contractDateAt;
  const [columns, setColumns] = useState<any[]>([]);
  const [showForm, setShowForm] = useState(false);
  const valuesResultsPages = [50, 100, 250, 500];

  const uploadDocument = () => {
    dispatch.messageModal.setMessageModal({
      show: true,
      title: `Cargar nuevos contratos`,
      onClose() {
        dispatch.messageModal.cleanStateMessage();
        dispatch.linkDocument.cleanState();
      },
      size: "medium",
      description: <ModalContract />,
    });
  };

  const toogleShowForm = () => setShowForm((prev) => !prev);

  const getDatePickerConfig = (): DatePickerConfig => ({
    contractDateService: buildDatePickerRange(
      startContractDateAt,
      endContractDateAt,
    ),
  });

  const getValueDatePickerStart = (name: keyof DatePickerConfig): Date | null =>
    getDatePickerConfig()[name]!.start();
  const getValueDatePickerEnd = (name: keyof DatePickerConfig): Date | null =>
    getDatePickerConfig()[name]!.end();
  const maxDate = (name: keyof DatePickerConfig): Date =>
    getDatePickerConfig()[name]!.max();

  const onChangesDatePicker = (update: any) => {
    setContractDateAt(update);
  };

  const buildUrl = (valuesUrl: any) => {
    const url = `${GET_CONTRACTS_NUMBER}`;
    const params = {
      contractNumber: valuesUrl.contractNumber,
      employerIdNumber: valuesUrl.nitEntidad,
      contractStartAt: startContractDateAt
        ? dayjs.utc(startContractDateAt).format("YYYY-MM-DD")
        : "",
      contractEndAt: endContractDateAt
        ? dayjs.utc(endContractDateAt).format("YYYY-MM-DD")
        : "",
      statusContract: valuesUrl.statusContract,
      size: "50",
    };
    return { params, url };
  };

  const { handleChange, handleSubmit, values } = useFormik({
    initialValues: {
      contractNumber: "",
      nitEntidad: "",
      statusContract: true,
    },
    onSubmit: (vls) => {
      const result = buildUrl(vls);
      // saveSearchHistoryAutorizationPayments(result)
      dispatch.electronicDocuments.getElectronicDocuments(
        result.params,
        result.url,
      );
    },
    validateOnChange: false,
    enableReinitialize: true,
  });

  useEffect(() => {
    setDataFields(fieldsFormContracts);
  }, []);

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(4);
    dispatch.electronicDocuments.getElectronicDocuments(
      { size: "50" },
      GET_CONTRACTS_NUMBER,
    );
  }, []);

  useEffect(() => {
    const columnsTransform: any[] = [
      ...columnsGridContracts(),
      {
        field: "actions",
        headerName: "",
        minWidth: 120,
        renderCell(params: columnsContractsType) {
          return (
            <MenuActions>
              <MenuItem>
                <ButtonAction roles={accesRoles.usersSSSA} disabled={false}>
                  <Link
                    to={`/consulta_documentos_electronicos/detalle_documento/undefined/ver_detalle_contrato/${params?.contractId}`}
                    data-testid="link-detailed"
                  >
                    Ver contrato
                  </Link>
                </ButtonAction>
              </MenuItem>
            </MenuActions>
          );
        },
      },
    ];
    setColumns(columnsTransform);
  }, [content]);

  return {
    dataFields,
    getValueDatePickerStart,
    getValueDatePickerEnd,
    maxDate,
    onChangesDatePicker,
    handleChange,
    handleSubmit,
    toogleShowForm,
    uploadDocument,
    showForm,
    values,
    columns,
    valuesResultsPages,
    loading,
  };
};
